module.exports = __webpack_public_path__ + "img/excellence1.3290fbc6.png";